const registerAnimations = () => {

  const $ = window.$;

  function msieversion() 
  {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
  
      if (msie > 0) // If Internet Explorer, return version number
      {
          //alert(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
      return true;
      }
      else  // If another browser, return 0
      {
         // alert('otherbrowser');
      return false;
      }
  
      
  }
  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  var isEdge = navigator.appVersion.indexOf("Edge");
  
  var windowHeight = window.innerHeight;
  var windowWidth = window.innerWidth;
  var prepare = windowHeight/4;
  
  $(document).ready(function(){
    var windowScroll = $(window).scrollTop();
    var soleFeatures = $('.sole-features-cont').offset().top;
    var feathers = $('.feathers').offset().top;
    $('.sole-features').addClass('animatable');
    
    if(msieversion() || isIE11 || isEdge !== -1){
      $('html').addClass('ie');
    }
    
    if((windowScroll + windowHeight - prepare*2 ) > soleFeatures){
      $('.sole-features').addClass('animate');
    }
    if((windowScroll + windowHeight -  prepare) > feathers){
      //$('.feathers img').addClass('fallInDown');
      $('.feathers img').addClass('fadeInDown');
    }
   
    $(window).on('scroll', function(){
      var slipper = $('#slipper-animation').offset().top;
       soleFeatures = $('.sole-features-cont').offset().top;
      
      var slipperScrollUpTO = 215; 
      if(windowWidth >= 375 && windowWidth < 410){
        slipperScrollUpTO = 250;
      }
      if(windowWidth >= 410 && windowWidth < 480){
        slipperScrollUpTO = 300;
      }
      if(windowWidth >= 480 && windowWidth < 768){
        slipperScrollUpTO = 350;
      }
      if(windowWidth >= 768 && windowWidth < 1200){
        slipperScrollUpTO = 350;
      }
      if(windowWidth >= 1200 && windowWidth < 1440){
        slipperScrollUpTO = 450;
      }
      if(windowWidth >= 1440 && windowWidth < 1600){
        slipperScrollUpTO = 520;
      }
      if(windowWidth >= 1600){
        slipperScrollUpTO = 580;
      }
  
      windowScroll = $(window).scrollTop();
      var slipperScroll = windowScroll + windowHeight - slipper - prepare;
      if((windowScroll + windowHeight - prepare ) > slipper && slipperScroll > 0){
        //console.log(windowScroll);
        if(slipperScroll <= slipperScrollUpTO){
          $("#layer-inside").css({'transform': 'translateY('+slipperScroll/2.3+'px)',});
          $("#layer-bottom").css({'transform': 'translateY('+slipperScroll/1.6+'px)',});
          $("#layer-base").css({'transform': 'translateY('+slipperScroll/1.3+'px)',});
        }else{
          //console.log("slipperScrollUpTO : " + slipperScrollUpTO + " | slipperScroll : " + slipperScroll);
          
        }
      }else{
        $("#layer-inside").css({'transform': 'translateY('+0+'px)',});
        $("#layer-bottom").css({'transform': 'translateY('+0+'px)',});
        $("#layer-base").css({'transform': 'translateY('+0+'px)',});
      }
      
      if((windowScroll + windowHeight - prepare*2.5 ) > soleFeatures){
        $('.sole-features').addClass('animate');
      }
      
      if((windowScroll + windowHeight -  prepare) > feathers){
        //$('.feathers img').addClass('fallInDown');
        $('.feathers img').addClass('fadeInDown');
      }
    });
  });
}

export default registerAnimations;